import { AlloyButton, AlloyIcon } from 'cat-ecommerce-alloy';
import { useAddToCart } from '@app/hooks';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  SHOPPING_CART_ICON_WIDTH,
  SHOPPING_CART_ICON_HEIGHT
} from '../constants';
import styles from '../ProductRemanParts.module.scss';

const AddToCartCell = ({ item }) => {
  const { partNumber } = item;
  const quantity = useSelector(
    s => s.products?.priceAndAvailability?.[partNumber]?.quantity
  );
  const totalPrice = useSelector(
    s => s.products?.priceAndAvailability?.[partNumber]?.totalPrice
  );
  const sosCode = useSelector(
    s => s.products?.priceAndAvailability?.[partNumber]?.sosCode
  );
  const addToCartItem = {
    partNumber,
    quantity: quantity?.toString()
  };
  const { addToCart } = useAddToCart();

  const handleClick = () => {
    addToCart([addToCartItem], { x_calculateOrder: sosCode ? sosCode : '' });
  };
  return totalPrice ? (
    <AlloyButton
      buttonType="secondary"
      className={`p-0 ${styles['shoppingcart-button']}`}
      onClick={handleClick}
    >
      <AlloyIcon
        data-testid="info_shoppingcart"
        icon="icon-shoppingcart"
        width={SHOPPING_CART_ICON_WIDTH}
        height={SHOPPING_CART_ICON_HEIGHT}
        className={`u-fill--White ${styles['shoppingcart-icon']}`}
      />
    </AlloyButton>
  ) : null;
};

export default AddToCartCell;
AddToCartCell.propTypes = {
  item: PropTypes.shape({
    partNumber: PropTypes.string
  })
};
